import React, { useEffect, useState } from "react";
import { GenericDialog } from "../../../components/generic/GenericDialog";
import { Box, Grid2 as Grid, Stack } from "@mui/material";
import { GenericIconButton } from "../../../components/generic/GenericIconButton";
import { CaretLeft, CaretRight } from "@phosphor-icons/react";
import { ACTIVE } from "../../../enums/statusEnums";

export const CreatorGalleryDialog = ({ openGalleryDialog, handleCloseGalleryDialog, creatorDetails }) => {
  const images = creatorDetails?.user?.files?.filter((item) => item?.status === ACTIVE);
  const [currentImage, setCurrentImage] = useState({});
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleNextAndPrev = (isNext = true,) => {
    if (isNext) {
      setCurrentIndex((prev) => prev + 1);
    } else {
      setCurrentIndex((prev) => prev - 1);
    }
  };

  useEffect(() => {
    if (images) setCurrentImage(images[currentIndex]);
  }, [images, currentIndex]);

  return (
    <GenericDialog
      title={`${creatorDetails?.user?.name}'s Photos`}
      width={{ sm: '854px' }}
      openDialog={openGalleryDialog}
      handleClose={handleCloseGalleryDialog}
    >
      <Box sx={{ display: 'flex', justifyContent: 'center', margin: '15px 0' }}>
        <Grid container alignItems={'center'} spacing={{ xs: 0.5, sm: 3 }} >
          <Grid item>
            <GenericIconButton
              disabled={currentIndex === 0}
              color={'primary.main'}
              tooltip={'Previous'}
              icon={<CaretLeft size={28} />}
              onClick={() => handleNextAndPrev(false)}
            />
          </Grid>
          <Grid item>
            <Box sx={{
              width: { xs: '230px', sm: '293px', md: '393px', lg: '450px', xl: '330px' },
              height: { xs: '269px', sm: '400px', md: '500px', lg: '480px', xl: '350px' }
            }}>
              <img
                src={currentImage?.location}
                style={{
                  width: '100%',
                  height: '100%',
                  borderRadius: '20px',
                  objectFit: 'cover'
                }}
              />
            </Box>
          </Grid>
          <Grid item>
            <GenericIconButton
              disabled={currentIndex == (images?.length - 1)}
              onClick={() => handleNextAndPrev()}
              color={'primary.main'}
              tooltip={'Next'}
              icon={<CaretRight size={28} />}
            />
          </Grid>
        </Grid>
      </Box>
      <Stack direction={'row'} gap={1} justifyContent={'center'}>
        {
          images?.slice(0, 5)?.map((image, index) => {
            const sliceStart = currentIndex > 4 ? currentIndex - 4 : 0;
            const isCurrent = currentIndex === sliceStart + index;
            return (
              <Box key={`image-key-${index}`}>
                <img
                  src={image?.location}
                  style={{
                    width: '96px',
                    height: '96px',
                    borderRadius: '10px',
                    filter: isCurrent ? 'brightness(0.5)' : 'none',
                    objectFit: 'cover'
                  }}
                />
              </Box>
            );
          })
        }
      </Stack>
    </GenericDialog>
  );
};